import React, { useState } from 'react';
import './App.css';
import Header from './Header';
import Sidebar from './Sidebar';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Chat from './Chat'
import Login from './Login';
import { useStateValue } from './StateProvider';

function App() {
  const [{ user }, dispatch] = useStateValue();
 // const [user , setUser] = useState(null);
  console.log(user)

  return (
    <div className="app">
      <Router>
        {!user ? (
          <Login />
        ) : (

            <>
              <Header />
              <div className="app__body">
                <Sidebar />
                <Switch>
                  <Route path="/room/:roomId">
                    <Chat />
                  </Route>
                  <Route path="/">
                    <h3><h1>Welcome to MyTeam,</h1><h3>Click on Add Channel 
                    to create New Channel or </h3>  <h3>Go to your Channel</h3> </h3>  
                     
                  </Route>
                </Switch>
              </div>
            </>
          )}
      </Router>
    </div>
  );
}
//<h1>Click on add button to add channel</h1>
//<h1>Select channel to send message</h1>
/*<h3><h1>Welcome to MyTeam,</h1>  click on Add Channel 
                    to create New Channel or <h3>go to your Channel</h3> </h3>  */
export default App;
